import meeting10mSrc from 'images/meetings/calendar-duration-10m.svg'
import meeting15mSrc from 'images/meetings/calendar-duration-15m.svg'
import meeting30mSrc from 'images/meetings/calendar-duration-30m.svg'
import meeting45mSrc from 'images/meetings/calendar-duration-45m.svg'
import meeting60mSrc from 'images/meetings/calendar-duration-60m.svg'

export const MEETING_ICON_TO_DURATION = {
  '10': meeting10mSrc,
  '15': meeting15mSrc,
  '30': meeting30mSrc,
  '45': meeting45mSrc,
  '60': meeting60mSrc,
}

export const GATED_PROFILE_OPTIONS = {
  MEETING_LENGTH: { value: 60, label: '60 minutes' },
  BUFFER_LENGTH: { value: 0, label: 'No buffer time' },
  NOTICE_TIME: { value: 0, label: 'No minimum notice time' },
}

export const MEETING_LENGTH_OPTIONS = [
  { value: 15, label: '15 minutes' },
  { value: 30, label: '30 minutes' },
  { ...GATED_PROFILE_OPTIONS.MEETING_LENGTH },
]
export const CUSTOM_MEETING_LENGTH_OPTIONS = [
  { value: 10, label: '10 minutes' },
  { value: 15, label: '15 minutes' },
  { value: 30, label: '30 minutes' },
  { value: 45, label: '45 minutes' },
  { ...GATED_PROFILE_OPTIONS.MEETING_LENGTH },
]

export const BUFFER_LENGTH_OPTIONS = [
  { ...GATED_PROFILE_OPTIONS.BUFFER_LENGTH },
  { value: 15, label: '15 minutes' },
  { value: 30, label: '30 minutes' },
  { value: 60, label: '60 minutes' },
]

export const NOTICE_TIME_OPTIONS = [
  { ...GATED_PROFILE_OPTIONS.NOTICE_TIME },
  { value: 15, label: '15 minutes' },
  { value: 30, label: '30 minutes' },
  { value: 60, label: '1 hour' },
  { value: 120, label: '2 hours' },
  { value: 180, label: '3 hours' },
  { value: 240, label: '4 hours' },
  { value: 1440, label: '1 day' },
]



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/constants.js